import { render } from "./HomepageUzbrusselfoundation.vue?vue&type=template&id=a5cb28fc&scoped=true"
import script from "./HomepageUzbrusselfoundation.vue?vue&type=script&lang=js"
export * from "./HomepageUzbrusselfoundation.vue?vue&type=script&lang=js"

import "./HomepageUzbrusselfoundation.vue?vue&type=style&index=0&id=a5cb28fc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5cb28fc"]])

export default __exports__